import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { ProfilePage } from '@/features/auth/pages/profile-page/ProfilePage';

export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfilePage,
  loader: () => ({
    breadcrumb: t`My Profile`,
  }),
});
